import trackEvent from '@groove/api/analytics/trackEvent';

export function schedulerTimesInsertedEvent(
  provider: string | undefined,
  role: string | undefined,
  saved_meeting_applied: boolean,
  double_booking_enabled: boolean,
  plain_text_enabled: boolean,
  scheduled_for_another_user: boolean,
  time_zone_updated: boolean,
  attendees_added: boolean,
): void {
  try {
    trackEvent('Scheduler Times Inserted', {
      ui: 'scheduler',
      provider: provider || '',
      role: role || '',
      saved_meeting_applied,
      double_booking_enabled,
      plain_text_enabled,
      scheduled_for_another_user,
      time_zone_updated,
      attendees_added,
    });
  } catch (e) {
    console.log('schedulerTimesInsertedEvent failed:');
    console.error(e);
  }
}
